<template>
    <div>
        <project-modal :title="projectModalTitle" :model="projectObject" ref="projectModal" @done="projectDone"></project-modal>

        <!-- Left side column. contains the logo and sidebar -->
        <aside class="left-aside sidebar-offcanvas">
            <!-- sidebar: style can be found in sidebar-->
            <section class="sidebar">
                <div id="menu" role="navigation">
                    <div class="nav_profile">
                        <profile></profile>
                    </div>
                    <vmenu>
                        <template v-for="item in menuitems">
                            <div class="divider mt-3" v-if="item.title"></div>
                            <vsub-menu v-if="item.child" :title="$t(item.name)" :icon="item.icon" :level="1">
                                <div v-for="item2 in item.child">
                                    <div class="divider mt-3 " v-if="item2.title"></div>
                                    <vsub-menu :style="styleObject" v-if="item2.child" :title="$t(item2.name)" :icon="item2.icon" :level="2">
                                        <vmenu-item v-for="child in item2.child" :link="child.link" :icon="child.icon" :key="$t(child.name)">{{$t(child.name)}}</vmenu-item>
                                    </vsub-menu>
                                    <vmenu-item v-if="item2.link" :link="item2.link" :icon="item2.icon">{{$t(item2.name)}}</vmenu-item>
                                </div>
                            </vsub-menu>
                            <div v-if="item.click">
                                <vmenu-item :icon="item.icon" v-on:click="edit">{{$t(item.name)}}</vmenu-item>
                            </div>
                            <div v-else>
                                <vmenu-item v-if="item.link" :link="item.link" :icon="item.icon">{{$t(item.name)}}</vmenu-item>
                            </div>
                        </template>
                    </vmenu>
                    <!-- / .navigation -->
                    <div class="text-center" v-if="has_pagination" style="">
                        <paginate
                            v-model="page"
                            :page-count="pageCount"
                            :page-range="3"
                            :margin-pages="1"
                            :click-handler="paginationCall"
                            :prev-text="'&laquo;'"
                            :next-text="'&raquo;'"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class= "'page-link'"
                            :next-link-class= "'page-link'"
                            :prev-link-class= "'page-link'"
                            class="mt-1" 
                            style="align-items: center;justify-content: center;"
                            :class="$store.state.ajax_in_progress ? 'disabled-custom-class' : ''"
                        >
                        </paginate>
                    </div>
                </div>
                <!-- menu -->
            </section>
            <!-- /.sidebar -->
        </aside>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    vmenu,
    vmenuItem,
    vsubMenu
} from './menu';
import profile from "../left-profile/user_profile2.vue"
import default_project_menu from "./../../../../menu/project"

import ProjectModal from '@/components/global/modals/ProjectModal.vue';

export default {
    name: "left-side",
    components: {
        vmenu,
        vsubMenu,
        vmenuItem,
        profile,
        ProjectModal
    },
    data() {
        return {
            projectModalTitle: Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('general.projects.title_modal'),
            styleObject: {
                padding: '0px 0px 0px 15px',
            },

            projectObject: {

            },

            pageCount: 1,
            currentPage: 1,
            page: 1,
            has_pagination: false,

            project_get_tries: 0,

            project_routes: [
                'project_settings',
                'progress_settings',
                'progress_settings_steps',
                'milestones',
                'project_empty',
                'project_progress_reporting',
                'teams',
                'disciplines_project',
                'line_list',
                'isometric_management',
                'isometric_management_best_prefabrication',
                'isometric_management_best_erection',
                'pressure_test_planning',
                'blinds_and_removed_items',
                'tie_in_management',
                'subcontractors',
                'scaffolding',
                'punch_list',
                'spool_management',
                'site_instructions',
                'painting',
                'steel_drawings',
                'equipment_drawings',
                'civil_drawings',
                'ei_drawings',
                'other_drawings',
                'steel_drawings_parts',
                'equipment_items',
                'civil_drawings_parts',
                'ei_drawings_parts',
                'other_drawings_parts',
                'change_orders',
                'delays',
                'submittal',
                'tq',
                'general_documents',
                'isometric_management_parts',
                'companypricelist',
                'storage',
                'daily_logs',
                'daily_logs_users',
                'hours_recording',
                'team_members',
                'weld',
                'weld_iso',
                'current_welds',
                'ndt_welds',
                'documentation',
                'filler_material',
                'messages',
                'material_management',
                'isometric_material_request',
                'isometric_management_revisioncontrol',
                'pressure_test_planning_revisioncontrol',
                'weld_revisioncontrol',
                'scaffolding_parts',
                'steel_drawings_revisioncontrol',
                'equipment_drawings_revisioncontrol',
                'ei_drawings_revisioncontrol',
                'civil_drawings_revisioncontrol',
                'other_drawings_revisioncontrol',
                'line_list_revisioncontrol',
                'tie_in_management_revisioncontrol',
                'change_orders_revisioncontrol',
                'change_orders_parts',
                'calculation',
                'overview_piping',
                'overview_equipment',
                'overview_painting',
                'overview_scaffolding',
                'overview_insulation',
                'overview_steel',
                'overview_civil',
                'overview_ei',
                'overview_other',
                'overview_tie_in',
                'overview_change_order',
                'subcontractors_price_list',
                'task_manager',
                'project_parts',
                'isometric_material_requests',
                'change_order_material_requests',
                'calibrated_items',
                'progress_settings_steps_piping',
                'progress_settings_steps_equipment',
                'progress_settings_steps_ei',
                'progress_settings_steps_steelstructure',
                'progress_settings_steps_civil',
                'progress_settings_steps_painting',
                'progress_settings_steps_insulation',
                'piping_value',
                'piping_weight',
                'progress_welding',
                'progress_bw_welding',
                'other_discipline_equipment',
                'other_discipline_ei',
                'other_discipline_steelstructure',
                'other_discipline_civil',
                'other_discipline_painting',
                'other_discipline_insulation',
                'progress_calculation_piping',
                'progress_calculation_steel',
                'progress_calculation_equipment',
                'progress_calculation_civil',
                'progress_calculation_ei',
                'progress_calculation_other',
                'welding_documentation',
            ]
        }
    },
    computed:{
        menuitems: {
            get: function () {
                var menu_items = [];
                let role = this.$store.state.userSelectedRole;
                let projects_routes = ['projects'];
                this.has_pagination = false;

                if (projects_routes.indexOf(this.$route.name) != -1) {//check if in projects, get projects ordered by latest, with pagination
                    menu_items.push({
                        name:'general.dashboard.title',
                        link:'/',
                        icon:'fa fa-tachometer'
                    });
                    if (typeof this.menu_projects.data != 'undefined') {
                        for (var i=0; i < this.menu_projects.data.length; i++) {
                            menu_items.push({
                                name: this.menu_projects.data[i].name,
                                link:'/project/'+this.menu_projects.data[i].id,
                                icon:'fa fa-file-o'
                            });
                        }
                        if (this.menu_projects.pagination.totalPages > 1) {
                            this.has_pagination = true;
                            this.pageCount = this.menu_projects.pagination.totalPages;
                            this.currentPage = this.menu_projects.pagination.currentPage;
                        }
                    }
                } else if (this.project_routes.indexOf(this.$route.name) != -1) {//check if in project, show project menu
                    this.page = 1;
                    menu_items.push({
                        name:'general.dashboard.title',
                        link:'/',
                        icon:'fa fa-tachometer'
                    });
                    if (this.$store.getters.hasPermission(['project'])) {
                        menu_items.push({
                            name:Vue.i18n.translate('general.projects.back_to_projects'),
                            link:'/projects',
                            icon:'fa fa-arrow-left'
                        });
                        menu_items.push({
                            name: this.$store.state.current_project.name,
                            click:'edit',
                            icon:'fa fa-edit'
                        });
                    }
                    for (var i=0;i<default_project_menu.length;i++) {
                        if (typeof (default_project_menu[i].link) != 'undefined') {
                            if (this.$store.getters.hasPermission(default_project_menu[i].requiresPermissions)) {
                                menu_items.push({
                                    name: default_project_menu[i].name,
                                    link:'/project/'+this.$route.params.id+default_project_menu[i].link,
                                    icon:default_project_menu[i].icon,
                                });
                            }
                        } else {
                            var tmp = [];
                            for (var j=0;j<default_project_menu[i].child.length;j++) {
                                if (typeof (default_project_menu[i].child[j].link) != 'undefined') {
                                    if (this.$store.getters.hasPermission(default_project_menu[i].child[j].requiresPermissions)) {
                                        tmp.push({
                                            name: default_project_menu[i].child[j].name,
                                            link:'/project/'+this.$route.params.id+default_project_menu[i].child[j].link,
                                            icon:default_project_menu[i].child[j].icon,
                                        });
                                    }
                                } else {
                                    var tmp2 = [];
                                    for (var k=0;k<default_project_menu[i].child[j].child.length;k++) {
                                        if (this.$store.getters.hasPermission(default_project_menu[i].child[j].child[k].requiresPermissions)) {
                                            tmp2.push({
                                                name: default_project_menu[i].child[j].child[k].name,
                                                link:'/project/'+this.$route.params.id+default_project_menu[i].child[j].child[k].link,
                                                icon:default_project_menu[i].child[j].child[k].icon,
                                            });
                                        }
                                    }

                                    if (this.$store.getters.hasPermission(default_project_menu[i].child[j].requiresPermissions)) {
                                        tmp.push({
                                                name: default_project_menu[i].child[j].name,
                                                icon:default_project_menu[i].child[j].icon,
                                                child: tmp2
                                                });
                                    }
                                }
                            }

                            if (this.$store.getters.hasPermission(default_project_menu[i].requiresPermissions)) {
                                menu_items.push({
                                                name: default_project_menu[i].name,
                                                icon:default_project_menu[i].icon,
                                                child: tmp
                                                });
                            }
                        }
                    }

                    let refresh_project = false;
                    if (this.project_get_tries == 0) {
                        if (Object.keys(this.$store.state.current_project).length == 0) {
                            refresh_project = true;
                        } else if (this.$store.state.current_project.id != this.$route.params.id) {
                            refresh_project = true;
                        }
                    }
                    if (refresh_project) {
                        this.project_get_tries = 1;
                        this.$store.dispatch('getProjectInfo', this.$route.params.id).then(res => {
                            if (res.id) {
                                this.$store.commit('SET_CURRENT_PROJECT', res);
                                this.project_get_tries = 0;
                            } else {
                                this.$router.push('/');
                            }
                        });
                    }
                } else if (role) {//if normal page
                    if (role.role_type) {
                        try {
                            var tmp = require(`./../../../../menu/role/${role.role_type}`);

                            var default_menu = tmp.default;

                            for (var i=0;i<default_menu.length;i++) {
                                if (typeof (default_menu[i].link) != 'undefined') {
                                    if (this.$store.getters.hasPermission(default_menu[i].requiresPermissions)) {
                                        menu_items.push({
                                            name: default_menu[i].name,
                                            link:default_menu[i].link,
                                            icon:default_menu[i].icon,
                                        });
                                    }
                                } else {
                                    var tmp = [];
                                    for (var j=0;j<default_menu[i].child.length;j++) {
                                        if (typeof (default_menu[i].child[j].link) != 'undefined') {
                                            if (this.$store.getters.hasPermission(default_menu[i].child[j].requiresPermissions)) {
                                                tmp.push({
                                                    name: default_menu[i].child[j].name,
                                                    link:default_menu[i].child[j].link,
                                                    icon:default_menu[i].child[j].icon,
                                                });
                                            }
                                        } else {
                                            var tmp2 = [];
                                            for (var k=0;k<default_menu[i].child[j].child.length;k++) {
                                                if (this.$store.getters.hasPermission(default_menu[i].child[j].child[k].requiresPermissions)) {
                                                    tmp2.push({
                                                        name: default_menu[i].child[j].child[k].name,
                                                        link:default_menu[i].child[j].child[k].link,
                                                        icon:default_menu[i].child[j].child[k].icon,
                                                    });
                                                }
                                            }

                                            if (this.$store.getters.hasPermission(default_menu[i].child[j].requiresPermissions)) {
                                                tmp.push({
                                                        name: default_menu[i].child[j].name,
                                                        icon:default_menu[i].child[j].icon,
                                                        child: tmp2
                                                        });
                                            }
                                        }
                                    }

                                    if (this.$store.getters.hasPermission(default_menu[i].requiresPermissions)) {
                                        menu_items.push({
                                                        name: default_menu[i].name,
                                                        icon:default_menu[i].icon,
                                                        child: tmp
                                                        });
                                    }
                                }
                            }
                        } catch (ex) {
                            var tmp = require("./../../../../menu/default");//in case no specific role menu is defined

                            var default_menu = tmp.default;

                            for (var i=0;i<default_menu.length;i++) {
                                if (typeof (default_menu[i].link) != 'undefined') {
                                    if (this.$store.getters.hasPermission(default_menu[i].requiresPermissions)) {
                                        menu_items.push({
                                            name: default_menu[i].name,
                                            link:default_menu[i].link,
                                            icon:default_menu[i].icon,
                                        });
                                    }
                                } else {
                                    var tmp = [];
                                    for (var j=0;j<default_menu[i].child.length;j++) {
                                        if (typeof (default_menu[i].child[j].link) != 'undefined') {
                                            if (this.$store.getters.hasPermission(default_menu[i].child[j].requiresPermissions)) {
                                                tmp.push({
                                                    name: default_menu[i].child[j].name,
                                                    link:default_menu[i].child[j].link,
                                                    icon:default_menu[i].child[j].icon,
                                                });
                                            }
                                        } else {
                                            var tmp2 = [];
                                            for (var k=0;k<default_menu[i].child[j].child.length;k++) {
                                                if (this.$store.getters.hasPermission(default_menu[i].child[j].child[k].requiresPermissions)) {
                                                    tmp2.push({
                                                        name: default_menu[i].child[j].child[k].name,
                                                        link:default_menu[i].child[j].child[k].link,
                                                        icon:default_menu[i].child[j].child[k].icon,
                                                    });
                                                }
                                            }

                                            if (this.$store.getters.hasPermission(default_menu[i].child[j].requiresPermissions)) {
                                                tmp.push({
                                                        name: default_menu[i].child[j].name,
                                                        icon:default_menu[i].child[j].icon,
                                                        child: tmp2
                                                        });
                                            }
                                        }
                                    }

                                    if (this.$store.getters.hasPermission(default_menu[i].requiresPermissions)) {
                                        menu_items.push({
                                                        name: default_menu[i].name,
                                                        icon:default_menu[i].icon,
                                                        child: tmp
                                                        });
                                    }
                                }
                            }
                        }//end catch
                    }
                }
                return menu_items;
            }
        },
        menu_projects: {
            get: function () {
                return this.$store.getters.getMenuProjects;
            }
        },
    },
    watch: {
        menuitems: {
            immediate: true,

            handler(newVal, oldVal) {
            }
        },
        menu_projects: {
            immediate: true,

            handler(newVal, oldVal) {
            }
        },
    },
    mounted: function () {
    },
    methods: {
        // replaceIdInItem(items, id) {
        //     for (var i=0;i<items.length;i++) {
        //         if (typeof (items[i].link) != 'undefined') {
        //             let link = items[i].link;
        //             items[i].link = link.replace(':id', id);
        //         } else {
        //             items[i].child = this.replaceIdInItem(items[i].child, id);
        //         }
        //     }

        //     return items;
        // },
        paginationCall(page) {
            this.$store.dispatch('getUserProjects', {page: page}).then(res => {
                this.$store.commit('SET_USER_PROJECTS', res);
            });
        },
        edit() {
            let row = JSON.parse(JSON.stringify(this.$store.state.current_project));
            if (!this.$store.getters.hasPermission(['project'], ['update'])) {
                row.viewRow = true;
            }
            this.$refs.projectModal.loadVals(row);
            this.$refs.projectModal.show();
        },
        projectDone(proj) {
            this.$store.commit('SET_CURRENT_PROJECT', proj);
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../css/customvariables";

.left-aside {
    width: $left_menu_width;
    background: $leftmenu_color;
    background-repeat: repeat-y;
}

.navigation {
    padding: 0;
}

.divider {
    margin-top: 10px;
    list-style-type: none;
    border-bottom: 1px solid #ececec;
    padding-bottom: 6px;
}

.divider span {
    font-size: 15px;
    font-weight: 700;
    color: $divider-leftheader;
    margin: 20px 20px -15px 20px;
}

.sidebar {
    display: block;
    font-size: 14px;
    letter-spacing: 1px;
}

.content {
    display: block;
    width: auto;
    overflow-x: hidden;
    padding: 0 15px;
}

.badge-success {
    background-color: #22d69d;
}

.badge {
    padding: 0.60em 0.7em;
    border-radius: 0.75rem;
}

.nav_profile {
    border-bottom: 1px solid #eee;
}

.disabled-custom-class {
    pointer-events: none;
    opacity: 0.8;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/left-side/default/left-side.vue